module.exports = __webpack_public_path__ + "static/media/banner1.5be72bc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/jara/images/banner1.jpg
// module id = 575
// module chunks = 0